import React, { useState, useEffect } from 'react';
import { Maximize, UploadCloud, Expand } from 'lucide-react';
import DocumentPreview from '../../Create-Investment/documentpreview';
import { useDispatch, useSelector } from 'react-redux';
import { clearCurrentStep } from '../../../Redux/store/onboardingFormSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../../../Utils/toastContext';
import TermsModal from '../../../Components/TermPopup/term-popup';
import AgreementCard from '../../../Components/onboarding/agreement-card';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import {
  CreditCard,
  ShieldCheck,
  User,
  Calendar,
  Lock,
  Eye,
  EyeOff,
} from 'lucide-react';
const unwrapReviewValue = (value) => value?.value ?? value ?? null;

const reviewLabel = (key) =>
  String(key || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const reviewDocumentTypeName = (document) =>
  unwrapReviewValue(document?.document_type_name) ||
  unwrapReviewValue(document?.document_type)?.name ||
  document?.document_type_code ||
  'Additional document';

const reviewDocumentValue = (value) => {
  const unwrapped = unwrapReviewValue(value);
  if (unwrapped && typeof unwrapped === 'object') {
    return unwrapped.name || unwrapped.label || unwrapped.id || '';
  }
  return unwrapped ?? '';
};

const ReviewDocumentFile = ({ file, label, onClick }) => {
  const fileValue = unwrapReviewValue(file);
  if (!fileValue?.file_id && !fileValue?.file_name) return null;

  return (
    <button
      type="button"
      onClick={() => onClick?.(fileValue)}
      className="mt-2 flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left shadow-sm"
    >
      <span className="min-w-0 flex-1 overflow-hidden">
        <span className="block text-sm text-labelColour">{label}</span>
        <span
          className="block max-w-full truncate text-black underline"
          title={fileValue.file_name || 'View uploaded document'}
        >
          {fileValue.file_name || 'View uploaded document'}
        </span>
      </span>
      <span className="ml-3 shrink-0 text-xs font-medium text-[#375AE7]">
        View
      </span>
    </button>
  );
};

const ReviewSubmit = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const isInvitee = useSelector((state) => state.user.isInvitee);
  const isInviteeDirector = useSelector(
    (state) => state.user.isInviteeDirector,
  );
  const individualAccountType = useSelector(
    (state) => state.form.individualAccountType,
  );
  const [isBillingDifferent, setIsBillingDifferent] = useState(false);

  const [billingAddress, setBillingAddress] = useState({
    address: '',
    city: '',
    state: '',
    zip: '',
    country: '',
  });
  const [showCvv, setShowCvv] = useState(false);
  const [isAllCompleted, setIsAllCompleted] = useState(false);
  const [eddResponse, setEddResponse] = useState(null);
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const formData = useSelector((state) => state.form.formData);
  const [firstName, setFirstName] = useState('');
  const [profilePic, setProfilePic] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [apidata, setApidata] = useState('');

  const [otherActivity, setOtherActivity] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [fullName, setFullName] = useState('');
  const [formerNames, setFormerNames] = useState('');
  const [dob, setDob] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [stateId, setStateId] = useState('');
  const [countryCodeFirst, setCountryCodeFirst] = useState('');
  const [stateIdFirst, setStateIdFirst] = useState('');
  const [countryCodeSecond, setCountryCodeSecond] = useState('');
  const [stateIdSecond, setStateIdSecond] = useState('');

  const [redAddress, setRedAddress] = useState('');
  const [ownership, setOwnership] = useState('');
  const [applicantCountryText, setApplicantCountryText] = useState('');
  const [clientNo, setClientNo] = useState('CM0013189P');
  const [jointAccountID, setJointAccountID] = useState('');
  const [expectedAmount, setExpectedAmount] = useState('');
  const [signatory, setSignatory] = useState('yes');
  const [thirdPartySign, setThirdPartySign] = useState('yes');
  const [jointAccountName, setJointAccountName] = useState('');
  const [fileAttorney, setFileAttorney] = useState(null);
  const [taxResidentCountry, setTaxResidentCountry] = useState(1);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState('US');
  const [businessNature, setBusinessNature] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState('');
  const [nonResCountry, setNonResCountry] = useState(null);
  const [nonResCountryText, setNonResCountryText] = useState('');
  const [socialSecurityNumber, setSocialSecurityNumber] = useState('');
  const [taxId, setTaxId] = useState('');
  const [abn, setAbn] = useState('');
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState('');
  const [businessAddress, setBusinessAddress] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [businessActivity, setBusinessActivity] = useState('smaple text');
  const [businessActivityText, setBusinessActivityText] =
    useState('smaple text');
  const [fundSource, setFundSource] = useState('');
  const [transactionNature, setTransactionNature] = useState('');
  const [image, setImage] = useState('/avatar.svg');
  const [fullscreen, setFullscreen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [description, setDescription] = useState('');
  const [fileProof, setFileProof] = useState(null);
  const [proofAdditionalDocuments, setProofAdditionalDocuments] = useState([]);
  const [jointAccountMembers, setJointAccountMembers] = useState([]);
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [filePurpose, setFilePurpose] = useState('');
  const [accountPurpose, setAccountPurpose] = useState('');
  const [accountType, setAccountType] = useState(null);
  const [documentNumberSecond, setDocumentNumberSecond] = useState('');
  const [cardNumberSecond, setCardNumberSecond] = useState('');
  const [cardNumber, setCardNumber] = useState('');

  const [agreements, setagreements] = useState([]);
  // Payment fields
  const [cardName, setCardName] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvv, setCardCvv] = useState('');
  const [cardErrors, setCardErrors] = useState({});

  const secondheaders = [
    '',
    'First Name',
    'Last Name',
    'Email Address',
    'Mobile Number',
    'Account Type',
  ];
  const secondheadersWithAddress = [
    '',
    'First Name',
    'Last Name',
    'Email Address',
    'Mobile Number',
    'Residential Address',
    'Account Type',
  ];
  const [accountCount, setAccountCount] = useState(7);
  const [photoIdText, setPhotoIdText] = useState('');
  const [nonphotoIdText, setNonPhotoIdText] = useState('');
  const [nonphotoId, setNonPhotoId] = useState(null);
  const [photoId, setphotoId] = useState(1);
  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [expiryDate, setExpiryDate] = useState('02/12/2026');
  const [expiryDateSecond, setExpiryDateSecond] = useState('');
  const [photoIdFirst, setphotoIdFirst] = useState(1);
  const [photoIdFirstText, setphotoIdFirstText] = useState('');
  const [photoIdSecondText, setphotoIdSecondText] = useState('');
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [documentNumber, setDocumentNumber] = useState('');
  const [agreedMap, setAgreedMap] = useState([]);
  const [lockedAgreements, setLockedAgreements] = useState({});

  const [filePhotographicIdFirst, setfilePhotographicIdFirst] = useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [fileNonPhotographicId, setfileNonPhotographicId] = useState(null);
  const [personalDataId, setPersonalDataId] = useState(1);
  const [personalDataIdText, setPersonalDataIdText] = useState('');
  const [fileCV, setFileCV] = useState(null);
  const [webLink, setWebLink] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [isConfirmVerify, setIsConfirmVerify] = useState(false);
  const mapQuestions = (questions = []) => {
    const typeMap = {
      text: 1,
      radio: 2,
      select: 3,
      checkbox: 5,
      checkbox_with_percent: 6,
      multi_select: 6,
      file: 8,
    };

    return questions.map((q) => ({
      id: q.id,
      question: q.question_text,
      required: q.required,
      type: {
        value: typeMap[q.type.value] || 1,
      },
      options: (q.options || []).map((opt) => ({
        id: opt.id,
        label: opt.value,
        value: opt.value,
      })),
      answer: q.answer,
    }));
  };
  const pendingQuestions = mapQuestions(
    eddResponse?.pending?.[0]?.questions || [],
  );

  const completedQuestions = mapQuestions(
    eddResponse?.completed?.[0]?.questions || [],
  );

  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (formData) {
      dispatch(clearCurrentStep());
    }
  }, [formData]);
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const isAgreementAccepted = (agreement) => {
    return agreement.status === 'AGREED' || agreedMap[agreement.enum] === true;
  };

  const validateAgreementsBeforeNext = () => {
    const missing = agreements
      .map(mapAgreementUI)
      .filter((a) => a.required)
      .filter((a) => !isAgreementAccepted(a));

    return {
      isValid: missing.length === 0,
      missing,
    };
  };

  const mapAgreementUI = (agreement) => {
    return {
      id: agreement.agreement_type.id,
      enum: agreement.agreement_type.enum,
      name: agreement.agreement_type.name,
      description: agreement.agreement_type.description,
      required: agreement.is_required,
      mode: agreement.mode.enum, // UPLOAD_SIGNED | PREVIEW_TICK
      document: agreement.document,
      preview: agreement.preview_document,
      status: agreement.status.enum,
    };
  };

  const formatCardNumber = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 16);
    return digits.replace(/(\d{4})(?=\d)/g, '$1 ');
  };

  const formatExpiry = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 4);
    if (digits.length <= 2) return digits;
    return digits.slice(0, 2) + '/' + digits.slice(2);
  };

  const detectCardBrand = (num) => {
    const digits = num.replace(/\D/g, '');
    if (digits.startsWith('4')) return 'visa';
    if (/^5[1-5]/.test(digits)) return 'mastercard';
    if (digits.startsWith('34') || digits.startsWith('37')) return 'amex';
    return 'unknown';
  };

  const maskedCardNumber = (num) => {
    const digits = num.replace(/\D/g, '');
    if (!digits) return '•••• •••• •••• ••••';
    const padded = digits.padStart(16, '•');
    return padded.replace(/(\d{4})(?=\d)/g, '$1 ');
  };
  const getEddResponses = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/customer/edd/responses`);
      if (response.status == 200) {
        setEddResponse(response.data);
      }
    } catch (err) {
      setEddResponse({});
      showToast(err.message, 'error');
    }
  };

  const getAgreements = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/onboarding/agreements`);

      if (response.status == 200) {
        setagreements(response.data.agreements);
        const agreedMapFromApi = {};
        const lockedMapFromApi = {};

        response.data.agreements.forEach((item) => {
          const enumKey = item.agreement_type.enum;
          const isAccepted = item.status?.enum === 'AGREED' || !!item.agreed_at;

          agreedMapFromApi[enumKey] = isAccepted;
          lockedMapFromApi[enumKey] = isAccepted;
        });

        setAgreedMap(agreedMapFromApi);
        setLockedAgreements(lockedMapFromApi);
        setIsAllCompleted(response.data.all_completed);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setIsAllCompleted(false);
    }
  };
  const submitAgreementAPI = async (agreementType) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/agreements/${agreementType}/agree`;
    let bodyData = {
      accepted: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAcceptAgreement = async (checked, agreement) => {
    let toastMessage = null;
    const enumKey = agreement.enum;

    if (lockedAgreements[enumKey]) return; // 🚫 already accepted
    try {
      setLoading(true);
      if (checked) {
        const response = await submitAgreementAPI(agreement.id);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getAgreements();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        isInvitee
          ? `/api/v1/onboarding/invited-user/review-submit/review`
          : `/api/v1/onboarding/customer/review-submit/status`,
      );

      if (response.status == 200) {
        //SignUp details
        setFirstName(response.data.open_account_information.first_name);
        setLastName(response.data.open_account_information.last_name);
        setEmail(response.data.open_account_information.email_address);
        setMobileNumber(
          response.data.open_account_information.country_code +
            response.data.open_account_information.mobile_number,
        );
        setCustomerType(
          response.data.open_account_information.account_type.name,
        );

        //Personal information
        setProfilePic(response.data.personal_information.profile_picture_file);
        setAccountType(response.data.personal_information.account_type);
        setFullName(response.data.personal_information.full_name);
        setFormerNames(response.data.personal_information.former_names);
        const date = new Date(response.data.personal_information.dob);
        const formattedDate = date.toLocaleDateString('en-GB');
        setDob(formattedDate);
        setRedAddress(
          response.data.personal_information.address.google_address,
        );
        setApplicantCountryText(
          response.data.personal_information.applicant_country.name,
        );
        setSocialSecurityNumber(
          response.data.personal_information.social_security_number,
        );
        setApplicantCountry(
          response.data.personal_information.applicant_country.id,
        );
        //    setClientNo(response.data.personal_information.client_id);
        if (
          response.data.personal_information.account_type.id != 1 &&
          response.data.personal_information.account_type.id != 5
        ) {
          setJointAccountID(
            response.data.personal_information.joint_account.unique_id,
          );
          if (
            response.data.personal_information.joint_account.invitations
              .length > 0
          ) {
            const transformed =
              response.data.personal_information.joint_account.invitations.map(
                (item) => {
                  const apiAddress = item.address;

                  // Safely transform backend address to the structure your component expects
                  const formattedAddress = apiAddress
                    ? {
                        full: apiAddress.google_address || '',
                        street: apiAddress.street_number
                          ? `${apiAddress.street_number} ${
                              apiAddress.street_name || ''
                            }`.trim()
                          : apiAddress.address_line_1 || '',
                        route: apiAddress.address_line_2 || '',
                        city: apiAddress.city?.name || '',
                        state: apiAddress.state?.name || '',
                        country: apiAddress.country?.name || '',
                        zip: apiAddress.postal_code || '',
                      }
                    : {
                        full: '',
                        street: '',
                        route: '',
                        city: '',
                        state: '',
                        country: '',
                        zip: '',
                      };

                  return {
                    firstName: item.invitee_first_name || '',
                    lastName: item.invitee_last_name || '',
                    dob: '', // not provided
                    email: item.invitee_email || '',
                    countryCode: item.invitee_country_code || 'AU(+61)',
                    mobile: item.invitee_mobile_number || '',
                    address: formattedAddress,
                    accountType: 'individual',
                    errors: {
                      email: '',
                      mobile: '',
                    },
                  };
                },
              );

            setJointAccountMembers(transformed);
            let jointUserSoleSignatory =
              response.data.personal_information.joint_account.invitations.filter(
                (item) => item.proposed_is_sole_signatory == true,
              );
            if (jointUserSoleSignatory.length > 0) {
              setJointAccountName(
                jointUserSoleSignatory[0].invitee_first_name +
                  ' ' +
                  jointUserSoleSignatory[0].invitee_last_name,
              );
            } else {
              setJointAccountName('Myself');
            }
          }
          setSignatory(
            response.data.personal_information.is_sole_signatory == true
              ? 'yes'
              : 'no',
          );
          setFileAttorney(
            response.data.personal_information.power_of_attorney_file,
          );
        }
        // Business Info
        if (individualAccountType == 5) {
          setTaxResidentCountry(
            response.data.business_information.tax_resident_country.id,
          );
          setTaxResidentCountryText(
            response.data.business_information.tax_resident_country.name,
          );
          if (response.data.business_information.tax_resident_country.id == 2) {
            setNonResCountry(response.data.business_information.country.id);
            setNonResCountryText(
              response.data.business_information.country.name,
            );
          }
          setBusinessAddress(
            response.data.business_information.address.google_address,
          );
          setBusinessName(response.data.business_information.business_name);

          if (response.data.business_information.tax_resident_country.id == 1) {
            setAbn(response.data.business_information.abn);
          }
          if (response.data.business_information.tax_resident_country.id != 1) {
            setBusinessRegistrationNumber(
              response.data.business_information.business_registration_number,
            );

            setBusinessActivityText(
              response.data.business_information.business_activity.name,
            );
            setBusinessActivity(
              response.data.business_information.business_activity.id,
            );
            setOtherActivity(
              response.data.business_information.other_business_activity,
            );
            setAccountPurpose(
              response.data.business_information.purpose_of_opening_account,
            );
            setFilePurpose(response.data.business_information.documents[0]);

            setTransactionNature(
              response.data.business_information
                .nature_n_level_of_intended_transactions,
            );
            setFundSource(response.data.business_information.source_of_funds);
            setOwnership(
              response.data.business_information
                .beneficial_ownership_with_caprock == true
                ? 'Yes'
                : 'No',
            );
            if (
              response.data.business_information.tax_resident_country.id == 3
            ) {
              setTaxId(response.data.business_information.tax_id);
            }
          }
        }
        setImage(response.data.liveness_proof.selfie);
        // Upload docs
        setThirdPartySign(
          response.data.proof_documents.has_prosecution_history == true
            ? 'yes'
            : 'no',
        );
        setDescription(response.data.proof_documents.prosecution_description);
        setFileProof(response.data.proof_documents.prosecution_file);
        const proofDocuments = response.data.proof_documents || {};
        const photographicDocuments =
          proofDocuments.photographic_documents || [];
        const isAustralianApplicant =
          response.data.personal_information.applicant_country.id == 14;

        setProofAdditionalDocuments([
          ...(proofDocuments.additional_documents || []),
          ...(isAustralianApplicant ? photographicDocuments.slice(1) : []),
        ]);
        if (response.data.personal_information.applicant_country.id == 14) {
          setphotoId(
            response.data.proof_documents.photographic_documents[0]
              .document_type.id,
          );
          setPhotoIdText(
            response.data.proof_documents.photographic_documents[0]
              .document_type.name,
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date.split(
              'T',
            )[0],
          );
          setCountryCode(
            response.data.proof_documents.photographic_documents[0]
              ?.country_of_issue ?? '',
          );
          /* FIX (passport state_of_issue): state_of_issue can be null
             (e.g. passports) — guard the dereference so the page does
             not crash. */
          if (
            response.data.proof_documents.photographic_documents[0]
              ?.country_of_issue?.id == 14
          ) {
            setStateId(
              response.data.proof_documents.photographic_documents[0]
                ?.state_of_issue?.name ?? '',
            );
          }
          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_documents?.photographic_documents[0]
              ?.card_number,
          );
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.id != 2
          ) {
            setFilePhotographicId(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setNonPhotoId(
              response.data.proof_documents?.non_photogenic_id_type,
            );
            setNonPhotoIdText(
              response.data.proof_documents?.non_photogenic_id_type_name,
            );
            setfileNonPhotographicId(
              response.data.proof_documents.non_photogenic_file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.id == 2
          ) {
            setFileDriverLinsenceFront(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBack(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
        }

        if (response.data.personal_information.applicant_country.id != 14) {
          setphotoIdFirst(
            response.data.proof_documents.photographic_documents[0]
              .document_type.id,
          );
          setphotoIdFirstText(
            response.data.proof_documents.photographic_documents[0]
              .document_type.name,
          );
          setCountryCodeFirst(
            response.data.proof_documents.photographic_documents[0]
              ?.country_of_issue ?? '',
          );
          /* FIX (passport state_of_issue): state_of_issue can be null
             (e.g. passports) — guard the dereference so the page does
             not crash. */
          if (
            response.data.proof_documents.photographic_documents[0]
              ?.country_of_issue?.id == 14
          ) {
            setStateIdFirst(
              response.data.proof_documents.photographic_documents[0]
                ?.state_of_issue?.name ?? '',
            );
          }
          if (response.data.proof_documents.photographic_documents[1]) {
            setphotoIdSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_type.id,
            );
            setphotoIdSecondText(
              response.data.proof_documents.photographic_documents[1]
                .document_type.name,
            );
            setDocumentNumberSecond(
              response.data.proof_documents.photographic_documents[1]
                .document_number,
            );
            setCardNumberSecond(
              response.data.proof_documents?.photographic_documents[1]
                ?.card_number,
            );
            setExpiryDateSecond(
              response.data.proof_documents.photographic_documents[1].expiry_date.split(
                'T',
              )[0],
            );
            setCountryCodeSecond(
              response.data.proof_documents.photographic_documents[1]
                ?.country_of_issue ?? '',
            );
            setNonPhotoId(
              response.data.proof_documents?.non_photogenic_id_type,
            );
            setNonPhotoIdText(
              response.data.proof_documents?.non_photogenic_id_type_name,
            );
            setfileNonPhotographicId(
              response.data.proof_documents.non_photogenic_file,
            );
            /* FIX (passport state_of_issue): state_of_issue can be null
               (e.g. passports) — guard the dereference so the page does
               not crash. */
            if (
              response.data.proof_documents.photographic_documents[1]
                ?.country_of_issue?.id == 14
            ) {
              setStateIdSecond(
                response.data.proof_documents.photographic_documents[1]
                  ?.state_of_issue?.name ?? '',
              );
            }
          }

          setDocumentNumber(
            response.data.proof_documents.photographic_documents[0]
              .document_number,
          );
          setCardNumber(
            response.data.proof_documents?.photographic_documents[0]
              ?.card_number,
          );
          setExpiryDate(
            response.data.proof_documents.photographic_documents[0].expiry_date.split(
              'T',
            )[0],
          );

          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.id != 2
          ) {
            setfilePhotographicIdFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[0]
              .document_type.id == 2
          ) {
            setFileDriverLinsenceFrontFirst(
              response.data.proof_documents.photographic_documents[0].file,
            );
            setFileDriverLinsenceBackFirst(
              response.data.proof_documents.photographic_documents[0].back_file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.id != 2
          ) {
            setfilePhotographicIdSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
          }
          if (
            response.data.proof_documents.photographic_documents[1] &&
            response.data.proof_documents.photographic_documents[1]
              .document_type.id == 2
          ) {
            setFileDriverLinsenceFrontSecond(
              response.data.proof_documents.photographic_documents[1].file,
            );
            setFileDriverLinsenceBackSecond(
              response.data.proof_documents.photographic_documents[1].back_file,
            );
          }
        }

        setPersonalDataId(response.data.proof_documents.personal_details_type);
        setPersonalDataIdText(
          response.data.proof_documents.personal_details_type_name,
        );
        if (response.data.proof_documents.cv_file) {
          setFileCV(response.data.proof_documents.cv_file);
        }
        setWebLink(response.data.proof_documents.website_link);
        setApidata(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = isInvitee
      ? `${BASE_URL}/api/v1/onboarding/invited-user/review-submit/submit`
      : `${BASE_URL}/api/v1/onboarding/customer/review-submit/submit`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
        setIsConfirmSubmit(false);
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const withdrawApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/close`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const EditApplicationAPI = async (sectionId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/reopen-section?progress_id=${sectionId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleEdit = async (sectionId, stepId) => {
    let toastMessage = null;
    try {
      const response = await EditApplicationAPI(sectionId);
      if (response.status == 200) {
        setCurrentStep(stepId);
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleWithdraw = async () => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI();
      if (response.status == 200) {
        setIsConfirmWithdraw(false);
        navigate('/login');
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  useEffect(() => {
    getDetails();
    getAgreements();
    getEddResponses();
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] w-full max-w-full min-w-0 overflow-x-hidden">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999] p-4">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {((!isInvitee &&
          !isInviteeDirector &&
          stepStatus.length > 0 &&
          individualAccountType == 5 &&
          (stepStatus[4].status == 'IN_REVIEW' ||
            stepStatus[4].status == 'COMPLETED')) ||
          (!isInvitee &&
            !isInviteeDirector &&
            stepStatus.length > 0 &&
            individualAccountType != 5 &&
            (stepStatus[3].status == 'IN_REVIEW' ||
              stepStatus[3].status == 'COMPLETED')) ||
          ((isInvitee || isInviteeDirector) &&
            stepStatus.length > 0 &&
            (stepStatus[3].status == 'IN_REVIEW' ||
              stepStatus[3].status == 'COMPLETED'))) && (
          <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
            <img
              src="/warning-circle.svg"
              alt="Info"
              className="w-4 h-4 mr-2"
            />
            <span>
              Your application is{' '}
              <strong>in review by our onboarding team</strong>. You will be
              notified once the verification is complete.{' '}
            </span>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-2">
            <div className="flex items-center border-colour-custom space-x-2 px-4">
              <img
                src="/profile-circle-black.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">
                Open Account Information
              </h1>
            </div>

            <div className="bg-white">
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                {/* Column 1 */}
                <div className="flex flex-col px-4 pt-4">
                  <label className="mb-1 text-sm text-labelColour">
                    First Name
                  </label>
                  <span className="break-words max-w-full">{firstName}</span>

                  <label className="mb-1 mt-4 text-sm text-labelColour">
                    Last Name
                  </label>
                  <span className="break-words max-w-full">{lastName}</span>
                </div>

                {/* Column 2 */}
                <div className="flex flex-col mx-4 lg:pt-4 pt-0 border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-4">
                  <label className="mb-1 text-sm text-labelColour">Email</label>
                  <span className="break-all whitespace-normal max-w-full">
                    {email}
                  </span>

                  <label className="mb-1 mt-4 text-sm text-labelColour">
                    Mobile Number
                  </label>
                  <span className="break-words max-w-full">{mobileNumber}</span>
                </div>

                {/* Column 3 */}
                <div className="flex flex-col lg:pt-4 pt-0 px-4">
                  <label className="mb-1 text-sm text-labelColour">
                    Customer Type
                  </label>
                  <span className="break-words max-w-full">{customerType}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex flex-wrap justify-between items-start gap-2 border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img
                  src="/profile-circle-black.svg"
                  alt="User Avatar"
                  className="h-6 w-6"
                />
                <h1 className="text-xl font-medium">Personal Information</h1>
              </div>
              <img
                onClick={(e) => {
                  e.preventDefault();
                  handleEdit(stepStatus[0].id, 1);
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="bg-white border-b pb-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="firstName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Profile Picture
                  </label>
                  <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                    <img
                      src={profilePic?.presigned_url}
                      alt={`${firstName}`}
                      className="w-20 h-20 rounded-full object-cover"
                    />
                  </div>
                  {/* <label
                    htmlFor="advisorRefNumber"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Advisor Ref No
                  </label>
                  <span>{advisorRefNumber}</span> */}
                  <label
                    htmlFor="TypeOfCustomer"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Type Of Individual Customer
                  </label>
                  <span>{accountType ? accountType.name : ''}</span>
                  {applicantCountry == 233 && (
                    <>
                      <label
                        htmlFor="TypeOfCustomer"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Social Security Number
                      </label>
                      <span>{socialSecurityNumber}</span>
                    </>
                  )}
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-4">
                  <label
                    htmlFor="fullName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Full Name
                  </label>
                  <span>{fullName}</span>
                  {formerNames && formerNames.length > 0 && (
                    <>
                      {' '}
                      <label
                        htmlFor="formerNames"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Customer's Former Name(s)
                      </label>
                      <span>{formerNames}</span>
                    </>
                  )}
                  <label
                    htmlFor="dob"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Date of Birth
                  </label>
                  <span>{dob}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Residential Address
                  </label>
                  <span>{redAddress}</span>
                  <label
                    htmlFor="redAddress"
                    className="mb-1 mt-4 text-sm text-labelColour"
                  >
                    Applicant's Country
                  </label>
                  <span>{applicantCountryText}</span>
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <label
                    htmlFor="clientNo"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Client No
                  </label>
                  <span>{clientNo}</span>
                  {!isInvitee &&
                    !isInviteeDirector &&
                    accountType &&
                    accountType.id != 1 &&
                    accountType.id != 5 && (
                      <>
                        <label
                          htmlFor="jointAccountID"
                          className="mt-4 mb-1 text-sm text-labelColour"
                        >
                          Joint Account ID
                        </label>
                        <span>{jointAccountID}</span>
                      </>
                    )}
                </div>
              </div>
            </div>
            {!isInvitee &&
              !isInviteeDirector &&
              accountType &&
              accountType.id != 1 &&
              accountType.id != 5 && (
                <div className="bg-white mt-4">
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                    <h1 className="text-xl font-medium mb-2">
                      Joint Account Members
                    </h1>
                  </div>
                  <div className="overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 border-b mb-4 [scrollbar-width:thin]">
                    <table className="table-auto w-full min-w-[640px] h-full border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2 ">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C]  rounded-md mb-2 text-sm">
                        {accountType && accountType.id != 4 && (
                          <tr className="border border-[#EDEDED]">
                            {secondheaders.map((header, index) => (
                              <th
                                key={header}
                                className={`
                            cursor-pointer font-medium px-4 py-2 mb-5  text-left
                                        ${index === 0 ? 'w-[50px]' : 'w-auto'}

                            ${
                              index === 0
                                ? 'border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]' // Center column: Top and Bottom border only
                                : ''
                            }
                                ${
                                  index === 1 ||
                                  index === 2 ||
                                  index === 3 ||
                                  index === 4 ||
                                  index === 5 ||
                                  index === 6
                                    ? 'border-t border-b  border-[#EDEDED]' // Center column: Top and Bottom border only
                                    : ''
                                }
                              ${
                                index === 7
                                  ? 'border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]' // Center column: Top and Bottom border only
                                  : ''
                              }
                          `}
                              >
                                <div className="flex items-center">
                                  <span>{header}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        )}
                        {accountType && accountType.id == 4 && (
                          <tr className="border border-[#EDEDED]">
                            {secondheadersWithAddress.map((header, index) => (
                              <th
                                key={header}
                                className={`
                            cursor-pointer font-medium px-4 py-2 mb-5  text-left
                                        ${index === 0 ? 'w-[50px]' : 'w-auto'}

                            ${
                              index === 0
                                ? 'border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]' // Center column: Top and Bottom border only
                                : ''
                            }
                                ${
                                  index === 1 ||
                                  index === 2 ||
                                  index === 3 ||
                                  index === 4 ||
                                  index === 5 ||
                                  index === 6
                                    ? 'border-t border-b  border-[#EDEDED]' // Center column: Top and Bottom border only
                                    : ''
                                }
                              ${
                                index === 7
                                  ? 'border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]' // Center column: Top and Bottom border only
                                  : ''
                              }
                          `}
                              >
                                <div className="flex items-center">
                                  <span>{header}</span>
                                </div>
                              </th>
                            ))}
                          </tr>
                        )}
                      </thead>

                      {/* Table Body */}
                      <tbody className="text-sm mt-6  font-medium text-black">
                        {jointAccountMembers.length > 0 ? (
                          jointAccountMembers.map((member, idx) => (
                            <tr key={idx} className="mb-2 bg-[#F9F9F9]">
                              <td className="px-4 py-4 w-1 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {(idx + 1).toString().padStart(2, '0')}.
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.firstName}
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.lastName}
                              </td>
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.email}
                              </td>
                              <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                                <span className="text-[#888888]">
                                  {member.countryCode}{' '}
                                </span>
                                {member.mobile}
                              </td>
                              {accountType.id == 4 && (
                                <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                  {member.address.full}
                                </td>
                              )}
                              <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                                {member.accountType == 'individual'
                                  ? 'Individual'
                                  : 'Corporate'}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td className="text-center py-4" colSpan="7">
                              No results found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-4 border-t grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
                    <div className="flex flex-col px-2 md:pl-4 md:pr-0 pt-4">
                      {/* Label and Question */}
                      <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                        <label
                          htmlFor="investmentType"
                          className="block text-sm text-labelColour whitespace-normal break-words"
                        >
                          Is there going to be a Sole Signatory by providing a
                          Power Of Attorney?
                        </label>

                        {/* Radio Buttons */}
                        <div className="flex items-center gap-4 opacity-50 ">
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value="yes"
                              disabled={true}
                              checked={signatory === 'yes'}
                              className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                            />
                            <span className="">Yes</span>
                          </label>

                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value="no"
                              disabled={true}
                              checked={signatory === 'no'}
                              className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                            />
                            <span className="">No</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    {signatory == 'yes' && (
                      <>
                        <div className="flex flex-col lg:pt-4 pt-0  border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-2">
                          <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                            <label
                              htmlFor="jointAccountName"
                              className="mb-1 text-sm text-labelColour whitespace-normal break-words block"
                            >
                              Select which joint account members are going to be
                              the signatories
                            </label>
                            <span>{jointAccountName}</span>
                          </div>
                        </div>
                        <div className="flex lg:pt-4 pt-0 flex-col px-2">
                          <div className="flex items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-labelColour flex items-center"
                            >
                              Power of Attorney
                            </label>
                          </div>
                          {fileAttorney && (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(fileAttorney);
                              }}
                              className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                            >
                              <div className="flex-col flex">
                                <span className="text-black underline">
                                  {fileAttorney.file_name}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
          </div>
          {isModalOpen && currentDocument && (
            <DocumentPreview
              fileUrl={currentDocument.presigned_url}
              fileName={currentDocument?.file_name || currentDocument?.name}
              onClose={() => setIsModalOpen(false)}
            />
          )}
          {individualAccountType == 5 && (
            <div className="bg-white border rounded-md p-4 mt-4">
              <div className="flex flex-wrap justify-between items-start gap-2 border-colour-custom px-4">
                {/* Left Section: Icon + Heading */}
                <div className="flex items-center space-x-2">
                  <img
                    src="/buildings.svg"
                    alt="User Avatar"
                    className="h-6 w-6"
                  />
                  <h1 className="text-xl font-medium">Business Information</h1>
                </div>
                <img
                  onClick={(e) => {
                    e.preventDefault();
                    handleEdit(stepStatus[1].id, 2);
                  }}
                  src="/edit-details.svg"
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="applicantCountry"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Tax Resident Country
                  </label>
                  <span>{taxResidentCountryText}</span>
                  {taxResidentCountry == 2 && (
                    <>
                      <label
                        htmlFor="country"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Country
                      </label>
                      <span>{nonResCountryText}</span>
                    </>
                  )}

                  {taxResidentCountry != 1 && (
                    <>
                      <label
                        htmlFor="country"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Business Registration Number
                      </label>
                      <span>{businessRegistrationNumber}</span>
                    </>
                  )}
                  {taxResidentCountry == 3 && (
                    <>
                      <label
                        htmlFor="country"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Tax ID
                      </label>
                      <span>{taxId}</span>
                    </>
                  )}
                  {taxResidentCountry == 1 && (
                    <>
                      <label
                        htmlFor="abn"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        ABN
                      </label>
                      <span>{abn}</span>
                    </>
                  )}
                </div>
                <div className="flex flex-col lg:pt-4 pt-0  border-l-0 border-r-0 lg:border-l lg:border-r border-gray-300 px-4">
                  <label
                    htmlFor="businessName"
                    className="mb-1 text-sm text-labelColour"
                  >
                    Business Name
                  </label>
                  <span>{businessName}</span>
                  {taxResidentCountry != 1 && (
                    <>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Describe the business activity
                      </label>
                      <span>{businessActivityText}</span>
                      {businessActivity == 6 && (
                        <>
                          <label
                            htmlFor="businessAddress"
                            className="mb-1 mt-4 text-sm text-labelColour"
                          >
                            Please mention business activity
                          </label>
                          <span>{otherActivity}</span>
                        </>
                      )}
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Source of the funds including its origin
                      </label>
                      <span>{fundSource}</span>
                      <label
                        htmlFor="businessAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Purpose of opening account
                      </label>
                      <span>{accountPurpose}</span>
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm mt-4 text-labelColour flex items-center"
                        >
                          Additional documents
                        </label>
                      </div>
                      {filePurpose && (
                        <div
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileClick(filePurpose);
                          }}
                          className="cursor-pointer mt-2 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                        >
                          <div className="flex-col flex">
                            <span className="text-black underline">
                              {filePurpose.file_name}
                            </span>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                  <>
                    <label
                      htmlFor="businessAddress"
                      className="mb-1  text-sm text-labelColour"
                    >
                      Address of Principal Place of Business
                    </label>
                    <span>{businessAddress}</span>
                    {taxResidentCountry != 1 && (
                      <>
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 mt-4 text-sm text-labelColour break-words"
                        >
                          Nature and level of the intended transaction behaviour
                        </label>
                        <span>{transactionNature}</span>
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Beneficial ownership of the funds used by this account
                        </label>
                        <span>{ownership}</span>
                      </>
                    )}
                  </>
                </div>
              </div>
            </div>
          )}
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex flex-wrap justify-between items-start gap-2 border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/camera.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Prove Its You</h1>
              </div>
              <img
                onClick={(e) => {
                  e.preventDefault();
                  if (individualAccountType == 5) {
                    handleEdit(stepStatus[2].id, 3);
                  } else {
                    handleEdit(stepStatus[1].id, 2);
                  }
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
              <div className="flex flex-col px-4">
                <div>
                  <span className="text-sm text-[#A6A6A6]">Photo Upload</span>

                  {image && image.presigned_url && (
                    <div className="mt-2 relative w-full max-w-[240px] h-40 rounded-md overflow-hidden mx-auto sm:mx-0">
                      {/* Uploaded Image */}
                      <img
                        src={image.presigned_url}
                        alt="Uploaded"
                        className="w-full h-full object-cover"
                      />

                      {/* Fullscreen Button */}
                      <button
                        onClick={() => setFullscreen(true)}
                        className="absolute top-2 right-2 "
                      >
                        <img
                          src="/show-full.svg"
                          alt="Full Screen"
                          className="w-5 h-5 text-white"
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
              {fullscreen && (
                <div
                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4 py-6"
                  onClick={() => setFullscreen(false)}
                >
                  <img
                    src={image.presigned_url}
                    alt="Fullscreen"
                    className="max-w-full max-h-full object-contain rounded-md shadow-lg"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="bg-white border rounded-md p-4 mt-4">
            <div className="flex flex-wrap justify-between items-start gap-2 border-colour-custom px-4">
              {/* Left Section: Icon + Heading */}
              <div className="flex items-center space-x-2">
                <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
                <h1 className="text-xl font-medium">Upload Proof Documents</h1>
              </div>
              <img
                onClick={(e) => {
                  e.preventDefault();
                  if (individualAccountType == 5) {
                    handleEdit(stepStatus[3].id, 4);
                  } else {
                    handleEdit(stepStatus[2].id, 3);
                  }
                }}
                src="/edit-details.svg"
                alt="Edit Icon"
                className="w-4 h-4 cursor-pointer"
              />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 border-b pb-2">
              {/* first column */}
              <div className="flex flex-col px-4 pt-4 border-r-0 lg:border-r border-gray-300">
                <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                  <label
                    htmlFor="investmentType"
                    className="labelColour block whitespace-normal break-words text-sm text-labelColour flex items-center"
                  >
                    Details of any current or recent prosecutions and inquiries
                    related to Money Laundering, terrorist links, tax offences
                    and corruption in respect of the Individual
                  </label>

                  {/* Radio Buttons */}
                  <div className="flex items-center gap-4 opacity-50 ">
                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="thirdPartySign"
                        value="yes"
                        checked={thirdPartySign === 'yes'}
                        className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                      />
                      <span className="">Yes</span>
                    </label>

                    <label className="flex items-center text-sm text-black">
                      <input
                        type="radio"
                        name="thirdPartySign"
                        value="no"
                        checked={thirdPartySign === 'no'}
                        className="w-6 h-4 confirm-check  border-gray-300 focus:ring-[#375AE7]"
                      />
                      <span className="">No</span>
                    </label>
                  </div>
                </div>
                {thirdPartySign === 'yes' && (
                  <div className="mt-4">
                    <label
                      htmlFor="description"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Description
                    </label>
                    <span>{description}</span>
                  </div>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 pt-4 border-r-0 border-gray-300">
                {thirdPartySign === 'yes' && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload Proof
                      </label>
                    </div>
                    {fileProof && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileProof);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                      >
                        <div className="flex-col flex">
                          <span className="text-black underline">
                            {fileProof.file_name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4 pt-4"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 pt-2">
              {/* first column */}
              <div className="flex flex-col pr-4 border-r-0 lg:border-r border-gray-300">
                {applicantCountry == 14 && (
                  <>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Photographic ID
                      </label>
                    </div>
                    <span>{photoIdText}</span>

                    {(photoId == 1 || photoId == 3) && (
                      <>
                        {photoId == 1 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {photoId == 3 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        <div className="flex items-center justify-between">
                          {photoId == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Copy of Passport
                            </label>
                          )}
                          {photoId == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Photo ID issued under a State or Territory law
                            </label>
                          )}
                        </div>
                        {filePhotographicId && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicId);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicId.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoId == 2 && (
                      <>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumber}</span>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Card Number
                        </label>
                        <span>{cardNumber}</span>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Front)
                          </label>
                        </div>
                        {fileDriverLinsenceFront && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFront);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFront.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBack && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBack);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBack.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{' '}
                    </div>
                    <div className="mt-2">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCode?.name}</span>
                    </div>
                    {/* FIX (passport state_of_issue): a passport has no
                        state of issue — only render for non-passports. */}
                    {photoId != 1 && countryCode?.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateId}</span>
                      </div>
                    )}
                  </>
                )}
                {applicantCountry != 14 && (
                  <>
                    {/* first photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select First Photographic ID
                      </label>
                      <span>{photoIdFirstText}</span>
                    </div>
                    {(photoIdFirst == 1 || photoIdFirst == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdFirst == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport
                            </label>
                          )}
                          {photoIdFirst == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoIdFirst == 1 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {photoIdFirst == 3 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumber}</span>
                          </>
                        )}
                        {filePhotographicIdFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicIdFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdFirst == 2 && (
                      <>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumber}</span>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Card Number
                        </label>
                        <span>{cardNumber}</span>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Front)
                          </label>
                        </div>
                        {fileDriverLinsenceFrontFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFrontFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBackFirst && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackFirst);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBackFirst.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />
                    </div>
                    <div className="mt-2">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCodeFirst?.name}</span>
                    </div>
                    {/* FIX (passport state_of_issue): a passport has no
                        state of issue — only render for non-passports. */}
                    {photoIdFirst != 1 && countryCodeFirst?.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateIdFirst}</span>
                      </div>
                    )}
                    {/* second photo id */}
                    <div className="">
                      <label
                        htmlFor="firstName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Select Second Photographic ID
                      </label>
                      <span>{photoIdSecondText}</span>
                    </div>
                    {(photoIdSecond == 1 || photoIdSecond == 3) && (
                      <>
                        <div className="flex items-center justify-between">
                          {photoIdSecond == 1 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Notarised Foreign Government Issued
                              Passport
                            </label>
                          )}
                          {photoIdSecond == 3 && (
                            <label
                              htmlFor="investmentType"
                              className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                            >
                              Upload Photo ID issued under a State or Territory
                              law
                            </label>
                          )}
                        </div>
                        {photoIdSecond == 1 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Passport Number
                            </label>
                            <span>{documentNumberSecond}</span>
                          </>
                        )}
                        {photoIdSecond == 3 && (
                          <>
                            {' '}
                            <label
                              htmlFor="refId"
                              className="mb-1 mt-4 text-sm text-labelColour"
                            >
                              Document Number
                            </label>
                            <span>{documentNumberSecond}</span>
                          </>
                        )}
                        {filePhotographicIdSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(filePhotographicIdSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {filePhotographicIdSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {photoIdSecond == 2 && (
                      <>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Driver's License Number
                        </label>
                        <span>{documentNumberSecond}</span>
                        <label
                          htmlFor="refId"
                          className="mb-1 mt-4 text-sm text-labelColour"
                        >
                          Card Number
                        </label>
                        <span>{cardNumberSecond}</span>
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Front)
                          </label>
                        </div>
                        {fileDriverLinsenceFrontSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceFrontSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceFrontSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                        <div className="mt-2 flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload Copy of Driver's License (Back)
                          </label>
                        </div>
                        {fileDriverLinsenceBackSecond && (
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileClick(fileDriverLinsenceBackSecond);
                            }}
                            className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                          >
                            <div className="flex-col flex">
                              <span className="text-black underline">
                                {fileDriverLinsenceBackSecond.file_name}
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDateSecond}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{' '}
                    </div>
                    <div className="mt-2">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCodeSecond?.name}</span>
                    </div>
                    {/* FIX (passport state_of_issue): a passport has no
                        state of issue — only render for non-passports. */}
                    {photoIdSecond != 1 && countryCodeSecond?.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateIdSecond}</span>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* second column */}
              <div className="flex flex-col pr-4 border-r-0 lg:border-r border-gray-300">
                {photoId != 2 && (
                  <>
                    <label
                      htmlFor="investmentType"
                      className="text-sm text-labelColour  whitespace-normal break-words block"
                    >
                      Non Photographic ID
                    </label>
                    <span>{nonphotoIdText}</span>
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload Document
                      </label>
                    </div>
                    {fileNonPhotographicId && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileNonPhotographicId);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between gap-2 px-3 py-2 min-w-0"
                      >
                        <div className="flex-col flex">
                          <span className="text-black underline">
                            {fileNonPhotographicId.file_name}
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* third column */}
              <div className="flex flex-col pr-4"></div>
            </div>
          </div>
          {proofAdditionalDocuments.length > 0 && (
            <div className="bg-white border rounded-md p-4 mt-4">
              <div className="flex items-center space-x-2 border-colour-custom px-4">
                <span className="material-symbols-outlined text-xl">
                  description
                </span>
                <h1 className="text-xl font-medium">Additional Documents</h1>
              </div>
              <p className="px-4 pt-1 text-sm text-labelColour">
                Supporting identity documents submitted with your proof
                documents.
              </p>
              <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                {proofAdditionalDocuments.map((document, index) => {
                  const excludedKeys = new Set([
                    'id',
                    'document_type',
                    'document_type_code',
                    'document_type_name',
                    'file',
                    'back_file',
                  ]);
                  const fields = Object.entries(document).filter(
                    ([key, value]) =>
                      !excludedKeys.has(key) &&
                      value !== null &&
                      value !== undefined &&
                      value !== '',
                  );

                  return (
                    <div
                      key={
                        document.id || `${document.document_type_code}-${index}`
                      }
                      className="rounded-md border border-[#EDEDED] bg-[#F9F9F9] p-4"
                    >
                      <div className="mb-3 flex items-start justify-between gap-2">
                        <div>
                          <p className="text-xs text-labelColour">
                            Document {index + 1}
                          </p>
                          <h2 className="text-base font-medium text-slate-800">
                            {reviewDocumentTypeName(document)}
                          </h2>
                        </div>
                        <span className="rounded-full bg-[#375AE7]/10 px-2 py-1 text-[10px] font-semibold text-[#375AE7]">
                          Submitted
                        </span>
                      </div>

                      <div className="space-y-2">
                        {fields.map(([key, value]) => (
                          <div key={key}>
                            <p className="text-xs text-labelColour">
                              {reviewLabel(key)}
                            </p>
                            <p className="break-words text-sm text-slate-800">
                              {reviewDocumentValue(value)}
                            </p>
                          </div>
                        ))}
                      </div>

                      <ReviewDocumentFile
                        file={document.file}
                        label="Document file"
                        onClick={handleFileClick}
                      />
                      <ReviewDocumentFile
                        file={document.back_file}
                        label="Back file"
                        onClick={handleFileClick}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {isAllCompleted && (
            <div className="bg-white border rounded-md p-4 mt-4">
              <div className="flex flex-wrap justify-between items-start gap-2 border-colour-custom px-4">
                {/* Left Section: Icon + Heading */}
                <div className="flex items-center space-x-2">
                  <span
                    className={`material-symbols-outlined ml-2 text-xl transition-all duration-300`}
                  >
                    description
                  </span>
                  <h1 className="text-xl font-medium">Agreements</h1>
                </div>
              </div>
              <div className="mx-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
                  {agreements.map(mapAgreementUI).map((agreement) => (
                    <AgreementCard
                      key={agreement.enum}
                      agreement={agreement}
                      agreed={agreedMap[agreement.enum]}
                      isLocked={lockedAgreements[agreement.enum]}
                      onPreview={(e) => handleFileClick(e, agreement.preview)}
                      setAgreed={(checked) =>
                        handleAcceptAgreement(checked, agreement)
                      }
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
          {eddResponse?.pending.length > 0 ||
            (eddResponse?.completed.length > 0 && (
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-center w-full mt-2 md:mt-0">
                  <div className="flex items-center space-x-2 border rounded-xl w-full px-3 py-1.5 bg-yellow-50 border-yellow-300">
                    <p className="text-xs text-black">
                      Your enhaced due diligence questionnaire
                    </p>
                    <button
                      onClick={() => {
                        let redirectState = {
                          path: `/edd`,
                          state: {
                            from: location.pathname,
                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        };
                        sessionStorage.setItem(
                          'redirectAfterLogin',
                          JSON.stringify(redirectState),
                        );
                        navigate(`/edd`, {
                          state: {
                            from: location.pathname,
                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        });
                      }}
                      className="bg-black text-white text-xs rounded-full  px-3 py-1 font-medium"
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {isConfirmVerify && (
        <TermsModal
          onClose={() => setIsConfirmVerify(false)}
          onConfirm={() => {
            setIsConfirmVerify(false);
            setLoading(true);
            handleSubmit();
            // additional logic here
          }}
        />
      )}
      <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row gap-3 md:gap-4 p-3 sm:p-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:pb-4 bg-[#375AE7] sticky bottom-0 z-20 md:static w-full">
        {((!isInvitee &&
          !isInviteeDirector &&
          individualAccountType == 5 &&
          stepStatus[4] &&
          stepStatus[4].status !== 'COMPLETED' &&
          stepStatus[4].status !== 'APPROVED' &&
          stepStatus[4].status !== 'IN_REVIEW') ||
          (!isInvitee &&
            !isInviteeDirector &&
            individualAccountType != 5 &&
            stepStatus[3] &&
            stepStatus[3].status !== 'COMPLETED' &&
            stepStatus[3].status !== 'APPROVED' &&
            stepStatus[3].status !== 'IN_REVIEW') ||
          ((isInvitee || isInviteeDirector) &&
            stepStatus[3] &&
            stepStatus[3].status !== 'COMPLETED' &&
            stepStatus[3].status !== 'APPROVED' &&
            stepStatus[3].status !== 'IN_REVIEW')) && (
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4 relative">
            {/* Save as Draft */}
            <button
              onClick={() => {
                setIsConfirmWithdraw(true);
              }}
              className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Withdraw Application</span>
            </button>

            <button
              onClick={(e) => {
                e.preventDefault();
                if (isAllCompleted) {
                  setLoading(true);
                  handleSubmit();
                } else {
                  setIsConfirmSubmit(true);
                }
              }}
              className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Submit</span>
            </button>
          </div>
        )}
        {((!isInvitee &&
          !isInviteeDirector &&
          individualAccountType == 5 &&
          stepStatus[4] &&
          (stepStatus[4].status === 'COMPLETED' ||
            stepStatus[4].status === 'APPROVED' ||
            stepStatus[4].status === 'IN_REVIEW')) ||
          (!isInvitee &&
            !isInviteeDirector &&
            individualAccountType != 5 &&
            stepStatus[3] &&
            (stepStatus[3].status === 'COMPLETED' ||
              stepStatus[3].status === 'APPROVED' ||
              stepStatus[3].status === 'IN_REVIEW')) ||
          ((isInvitee || isInviteeDirector) &&
            stepStatus[3] &&
            (stepStatus[3].status === 'COMPLETED' ||
              stepStatus[3].status === 'APPROVED' ||
              stepStatus[3].status === 'IN_REVIEW'))) && (
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4 relative">
            {/* Save as Draft */}
            <button
              onClick={() => {
                navigate('/login');
              }}
              className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              <span>Back To Login</span>
            </button>
          </div>
        )}
      </footer>
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button className="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div className="flex justify-center items-center mb-4">
              <div className="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 className="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p className="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div className="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleWithdraw();
                }}
                className="px-6 py-2 bg-[#375AE7] text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
          <div className="w-full max-w-4xl max-h-[calc(100dvh-2rem)] sm:max-h-[90vh] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden">
            {/* HEADER */}
            <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b bg-gradient-to-r from-[#375AE7]/10 to-white">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-xl bg-[#375AE7]/10 text-[#375AE7]">
                  <span className="material-symbols-outlined text-xl">
                    description
                  </span>
                </div>

                <h1 className="text-lg md:text-xl font-semibold text-slate-800">
                  Agreements
                </h1>
              </div>

              <button
                onClick={() => setIsConfirmSubmit(false)}
                className="text-slate-500 hover:text-red-500 transition"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-y-auto overscroll-contain px-3 sm:px-6 py-4 sm:py-5 bg-slate-50">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
                {agreements.map(mapAgreementUI).map((agreement) => (
                  <div
                    key={agreement.enum}
                    className="bg-white rounded-xl shadow-sm border hover:shadow-md transition p-3"
                  >
                    <AgreementCard
                      agreement={agreement}
                      agreed={agreedMap[agreement.enum]}
                      isLocked={lockedAgreements[agreement.enum]}
                      onPreview={(e) => handleFileClick(e, agreement.preview)}
                      setAgreed={(checked) =>
                        handleAcceptAgreement(checked, agreement)
                      }
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            {/* FOOTER */}
            <div className="flex justify-between items-center px-6 py-4 border-t bg-white">
              {/* LEFT: Privacy Policy */}
              <p className="text-xs md:text-sm text-gray-600 text-center md:text-left">
                Please see our{' '}
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/privacy-policy');
                  }}
                  className="text-blue-600 font-medium hover:underline cursor-pointer"
                >
                  Privacy Policy
                </span>{' '}
                for information about how we process your data.
              </p>

              {/* RIGHT: Actions */}
              <div className="flex gap-3">
                <button
                  onClick={() => setIsConfirmSubmit(false)}
                  className="px-5 py-2 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-100 transition"
                >
                  Cancel
                </button>

                <button
                  onClick={(e) => {
                    e.preventDefault();

                    const { isValid, missing } = validateAgreementsBeforeNext();

                    if (!isValid) {
                      showToast(
                        'Please accept all required agreements. Missing: ' +
                          missing.map((a) => a.name).join(', '),
                        'error',
                      );
                      return;
                    }

                    setLoading(true);
                    handleSubmit();
                  }}
                  className="px-5 py-2 rounded-xl bg-[#375AE7] text-white font-medium hover:bg-[#2f4bd3] transition shadow-sm"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSubmit;
